import { useEffect, useState } from "react";
import "./pay.scss";
import LoadError from "../components/error";
import { useNavigate, useLocation } from "react-router-dom";
import { Elements, useElements, useStripe } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { PaymentElement } from "@stripe/react-stripe-js";
import { BrandButton, BrandButtonWhite } from "../components/form/buttons";
import { homeUrl } from "../components/utils";
import { Alert, Snackbar } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { setUserInfo, updatePaidExamStatus } from "../components/user";

interface PageProps {
  paymentIntentId?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  clientSecret?: any;
  token: string;
  userid: number;
  chargeAmount: number;
  examId: number;
}

interface CheckoutProps {
  token?: string;
  userid?: number;
  examId: number;
  chargeAmount: number;
}

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY as string);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const CheckoutForm = ({ token, userid, examId, chargeAmount }: CheckoutProps) => {
  const stripe = useStripe();
  const elements = useElements();
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [snackError, setSnackError] = useState(false);
  const vertical = "bottom";
  const horizontal = "center";

  const submitPayment = async () => {
    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }
    setLoading(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${homeUrl}#/register-confirm`,
      },
      redirect: "if_required",
    });

    if (error) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      setErrorMessage(error.message as any);
      setLoading(false);
    } else {
      if (examId === -1) {
        setUserInfo({ sat_app_paid: true, paid: true });
        setUserInfo({ couponCode: null });
      } else {
        updatePaidExamStatus(examId);
      }

      navigate("/pay-confirm", {
        replace: true,
      });
    }
  };

  useEffect(() => {
    const onEnter = (e: KeyboardEvent) => {
      if (e.key === "Enter") {
        e.preventDefault();
        submitPayment();
      }
    };
    document.addEventListener("keydown", onEnter);
    return () => {
      document.removeEventListener("keydown", onEnter);
    };
  }, [stripe, elements]);

  return (
    <div className="formHolder">
      <PaymentElement />
      <hr />
      <div className="btnHolder">
        {stripe && !loading ? (
          <div className="buttonOptions">
            <BrandButtonWhite onClick={
              () => navigate("/register-coupon", {state: {examId, examFee:chargeAmount}})}
            >
              <FontAwesomeIcon icon={faChevronLeft} /> Go Back
            </BrandButtonWhite>
            <BrandButton onClick={submitPayment} disabled={!stripe}>
              {" "}
              Submit Payment
            </BrandButton>
          </div>
        ) : (
          "loading..."
        )}
        {loading && <FontAwesomeIcon icon={faSpinner} />}
      </div>
      {errorMessage && <div className="errorMsg">{errorMessage}</div>}

      <Snackbar
        open={snackError}
        autoHideDuration={4000}
        onClose={() => setSnackError(false)}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert severity="error">
          Sorry, There was a problem processing your payment.
        </Alert>
      </Snackbar>
    </div>
  );
};

const RegisterPay = () => {
  const location = useLocation();
  const { paymentIntentId, clientSecret, token, userid, chargeAmount, examId } =
    (location.state as PageProps) || {};
  const options = {
    // passing the client secret obtained in step 3
    clientSecret: clientSecret,
    // Fully customizable with appearance API.
    appearance: {
      /*...*/
    },
  };

  if (!paymentIntentId && !clientSecret) return <LoadError />;

  return (
    <div className="payPage">
      <div className="headline">
        <h1>Payment</h1>
        <div
          className="description"
          dangerouslySetInnerHTML={{
            __html: `Please use the form below to pay for your exam.`,
          }}
        />
      </div>
      <h2>
        You will be charged <span>${chargeAmount}.00</span>
      </h2>
      <Elements stripe={stripePromise} options={options}>
        <CheckoutForm
          token={token}
          userid={userid}
          examId={examId}
          chargeAmount={chargeAmount}
        />
      </Elements>
    </div>
  );
};

export default RegisterPay;
